<div class="container-fluid sell_dash">
  <div class="wrapper">
    <div class="row">
      <app-sidemenu></app-sidemenu>
      <section class="right">
        <app-sellheader></app-sellheader>
        <div class="right-middle row justify-content-center">
          <div class="col-md-12 col-lg-10 col-xl-11 col-10 col-sm-10" id="top-nav" >
            <div class="row">
              <div class="col-sm-12">
                <div class="container-fluid">
                  <div>
                    <div class="search-form-box top-search" >
                      <div class="input-group" >
                        <div class="dropdown" id="filter">
                          <div class="select">
                            <span>Categories</span>
                            <i class="fa fa-chevron-left"></i>
                          </div>
                          <!-- <input type="hidden" name="Filter" id="filter" /> -->
                          <ul class="dropdown-menu">
                            <li value="Education">Education</li>
                            <li value="Health">Health</li>
                            <li value="Finance">Finance</li>
                          </ul>
                        </div>
                        <form action="https://www.google.com/search" method="get" target="_blank" class="form-control h100" name="s-form" id="s-form" >
                        <input
                          type="text"
                          name="q"
                          class="form-control click-me h100"
                          placeholder="Search Data Sets by name...."
                          autocomplete="off"
                          autofocus
                          id="in-2"
                          
                        >
                        <button
                        type="button"
                        class="btn btn-primary search-btn"
                        
                      >
                      <i class="fas fa-microphone"></i>
                      </button>
                      </form>
                      <!-- <p class="info"></p> -->
                        <ul
                          class="drop-menu text-left suggestion-search-menu add-scroll"
                        >
                          <li>
                            <a href="#" class="suggestion-anchor">
                              <div class="sleft">
                                <div class="media">
                                  <div class="s-tag">
                                    4.3
                                  </div>
                                  <div class="media-body">
                                    <h5>B.Tech Computer Science</h5>
                                    <p>Gautam Buddha University</p>
                                  </div>
                                </div>
                              </div>
                              <div class="sright">
                                <h5>Greater NoidaUttar Pradesh</h5>
                                <p>Gautam Buddha University</p>
                              </div>
                            </a>
                          </li>
                          <li>
                            <a href="#" class="suggestion-anchor">
                              <div class="sleft">
                                <div class="media">
                                  <div class="s-tag">
                                    4.3
                                  </div>
                                  <div class="media-body">
                                    <h5>B.Tech Computer Science</h5>
                                    <p>Gautam Buddha University</p>
                                  </div>
                                </div>
                              </div>
                              <div class="sright">
                                <h5>Greater NoidaUttar Pradesh</h5>
                                <p>Gautam Buddha University</p>
                              </div>
                            </a>
                          </li>
                          <li>
                            <a href="#" class="suggestion-anchor">
                              <div class="sleft">
                                <div class="media">
                                  <div class="s-tag">
                                    4.3
                                  </div>
                                  <div class="media-body">
                                    <h5>B.Tech Computer Science</h5>
                                    <p>Gautam Buddha University</p>
                                  </div>
                                </div>
                              </div>
                              <div class="sright">
                                <h5>Greater NoidaUttar Pradesh</h5>
                                <p>Gautam Buddha University</p>
                              </div>
                            </a>
                          </li>
                        </ul>
                        <div class="filterdrop" id="filter">
                          <div class="select">
                            <i class="fas fa-filter">&nbsp;&nbsp;<span class="filter-text">Filters</span></i>
                          </div>
                          <ul class="dropdown-menu">
                            <li (click)="type()"><i class="fas fa-plus" style="color: white;"></i>&nbsp;   Type</li>
                            <li [hidden]="istype"><label class="filter-container">One
                             <input type="checkbox" >
                             <span class="checkmark"></span>
                           </label></li>
                            <li [hidden]="istype"><label class="filter-container">One
                             <input type="checkbox" >
                             <span class="checkmark"></span>
                           </label></li>
                            <li [hidden]="istype"><label class="filter-container">One
                             <input type="checkbox" >
                             <span class="checkmark"></span>
                           </label></li>
                            <li (click)="price()"><i class="fas fa-plus" style="color: white;"></i>&nbsp;  Price</li>
                            <li [hidden]="isprice"><label class="filter-container">One
                             <input type="checkbox" >
                             <span class="checkmark"></span>
                           </label></li>
                            <li [hidden]="isprice"><label class="filter-container">One
                             <input type="checkbox" >
                             <span class="checkmark"></span>
                           </label></li>
                            <li [hidden]="isprice"><label class="filter-container">One
                             <input type="checkbox" >
                             <span class="checkmark"></span>
                           </label></li>
                            <li (click)="category()"><i class="fas fa-plus" style="color: white;"></i>&nbsp;  Category</li>
                            <li [hidden]="iscategory"><label class="filter-container">One
                             <input type="checkbox" >
                             <span class="checkmark"></span>
                           </label></li>
                            <li [hidden]="iscategory"><label class="filter-container">One
                             <input type="checkbox" >
                             <span class="checkmark"></span>
                           </label></li>
                            <li [hidden]="iscategory"><label class="filter-container">One
                             <input type="checkbox" >
                             <span class="checkmark"></span>
                           </label></li>
                            <li (click)="classify()"><i class="fas fa-plus" style="color: white;"></i>&nbsp;  Classification</li>
                            <li [hidden]="isclassify"><label class="filter-container">One
                             <input type="checkbox" >
                             <span class="checkmark"></span>
                           </label></li>
                            <li [hidden]="isclassify"><label class="filter-container">One
                             <input type="checkbox" >
                             <span class="checkmark"></span>
                           </label></li>
                            <li [hidden]="isclassify"><label class="filter-container">One
                             <input type="checkbox" >
                             <span class="checkmark"></span>
                           </label></li>
                          </ul>
                        </div>
                        <div class="btn cart-btn">
                          <i class="fas fa-shopping-cart"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12 col-lg-10 col-xl-11 col-10 col-sm-10 space">
            <div class="row">
              <div class="col-sm-8">
                <div class="container-fluid">
                  <div class="row card-cart">
                    <div class="col-12">
                      <div class="card card-1" (mouseenter)="hovercard()" (mouseleave)="hovercard2()">
                        <div class="card-horizontal">
                          <div class="img-square-wrapper">
                            <div class="inner-div" style="background-image: url(assets/image/travel.jpg);"></div>
                            <div class="info">
                                <div class="info_content"><img src="../../../assets/image/testicon_realestate.png"><br><p>Real Estate</p></div>
                             </div>
                          </div>
                          <div class="card-body b1 wrapper">
                            <div class="row cardtext mt-3">
                              <div class="col-sm-9">
                                <h5>Real Estate Data</h5>
                              </div>
                              <div class="col-sm-2 pricing">
                                <h5>$ 40</h5>
                              </div>
                            </div>
                            <div class="row mt-2">
                              <div class="col-sm-8">
                                <p>Order Id: 1234-9786</p>
                              </div>
                              <div class="col-sm-4 text-center">
                                <a class="order_detail">Order Details</a>
                              </div>
                            </div>
                            <div class="row mt-2 cardoptions_row">
                              <div class="col-sm-2 cardoption">
                                <a><i class="fas fa-trash"></i>&nbsp;Delete</a>
                              </div>
                              <div class="col-sm-4 cardoption mid">
                               <a><i class="fas fa-heart" style="color: red;"></i>&nbsp;Save For Later</a>
                              </div>
                              <div class="col-sm-6 cardoption">
                                <a><i class="far fa-eye"></i>&nbsp;See More Like This</a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-sm-4 right-card">
                <div class="card card-2">
                  <div
                    class="card-img-top right-head card-header"
                    style="
                      background-image: url('../../../assets/image/FareSummary.png');
                    "
                  >
                    <div class="row">
                      <div class="col-sm-7">
                        <p class="right-head-p">Fare Summary</p>
                      </div>
                      <div class="col-sm-5 tk-bal">
                        <small>Token Balance</small>
                        <h3>2000</h3>
                      </div>
                    </div>
                  </div>
                  <div class="card-body">
                    <div class="row opt">
                      <div class="col-sm-12">
                        <div class="row">
                          <div class="col-sm-8">
                            <p class="tot">Base Charge:</p>
                          </div>
                          <div class="col-sm-4" style="text-align: center;">
                            <p></p>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-8">
                            <p class="tot">Taxes:</p>
                          </div>
                          <div class="col-sm-4" style="text-align: center;">
                            <p></p>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-8">
                            <p class="tot">Discount:</p>
                          </div>
                          <div class="col-sm-4" style="text-align: center;">
                            <p></p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row body-token">
                      <div class="col-sm-12 input">
                        <label>Apply Coupon</label>
                        <input type="text" placeholder="Enter Coupon Code" />
                      </div>
                    </div>
                    <div class="row body-amt">
                      <div class="col-sm-8">
                        <p class="tot">Total</p>
                      </div>
                      <div class="col-sm-4" style="text-align: center;">
                        <p></p>
                      </div>
                    </div>
                    <div class="row body-pay">
                      <div class="col-sm-12">
                        <div class="row info-btn">
                          <a><img src="../../../assets/image/info.png"></a>
                        </div>
                        <div class="row paybtn">
                          <button class="btn btn-primary" id="rzp-button1" (click)="pay()">
                            <span class="pay">Pay Now</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- begin::Sticky Toolbar -->
      <app-stickytoolbar></app-stickytoolbar>
      <!-- end::Sticky Toolbar -->
    </div>
  </div>
</div>
